var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"team-image",style:({
'background-image': 'url(' + _vm.item.image + ')',
'background-size': 'cover',
'background-position-x': _vm.xPosition,
'background-position-y': _vm.yPosition,
'margin-left': _vm.listMode ? '10px' : '0'
})},[(_vm.listMode)?_c('div',{staticClass:"circle position"},[_vm._v(" "+_vm._s(_vm.playerTypeNames[_vm.item.position - 1])+" ")]):_vm._e(),(_vm.listMode)?_c('div',{staticClass:"circle points",style:({'font-size': _vm.item.points >= 100 ? '8px' : '9px'})},[_vm._v(" "+_vm._s(_vm.item.rating.toFixed(1))+" ")]):_vm._e(),(_vm.listMode)?_c('div',{staticClass:"circle status"},[_c('i',{staticClass:"fas fa-check"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }